import request from '@/utils/httpRequest'

export default class CommunityConsultationService {
    queryCommunityConsultationById(id) {
        return request({
            url: '/small/wuyeSmallCommunityConsultation/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/small/wuyeSmallCommunityConsultation/startFlow',
            method: 'post',
            data: params
        })
    }
}   
